<template>
  <div class="chips-bar">
    <clean-chips-button
      :class="['chips-bar__clean-button', { 'chips-bar__clean-button--hidden': !showCleanButton }]"
      @click="$emit('cleanClick')"
    />
    <div :class="['chips-bar__container', { 'chips-bar__container--clean-hidden': !showCleanButton }]">
      <app-chip
        v-for="chip in chips"
        :id="chip.id"
        :key="chip.id"
        class="chips-bar__chip"
        :text="chip.text"
        :selected="chip.selected"
        @click="(e, id) => $emit('chipClick', e, id)"
      />
    </div>
  </div>
</template>

<script>
import CleanChipsButton from "./CleanChipsButton";
import AppChip from "./AppChip";

export default {
  name: "AppChipsBar",
  components: { CleanChipsButton, AppChip },
  props: {
    chips: {
      type: Array,
      required: true
    },
    showCleanButton: Boolean
  }
};
</script>

<style scoped lang="scss">
.chips-bar {
  width: 100%;
  max-width: $max-width-desktop;
  margin: auto;
  height: auto;
  box-sizing: border-box;
  display: -webkit-box;

  &__title {
    font-size: 20px;
    max-width: $max-width-desktop;
    margin: auto;
    padding-left: $spacer;
  }

  &__container {
    position: relative;
    transition: transform 0.7s, width 0.7s;
    width: calc(100% - 36px);
    max-width: $max-width-desktop;
    margin: 0;
    padding-bottom: 12px;
    height: auto;
    box-sizing: border-box;
    display: -webkit-box;
    overflow-x: auto;

    &--clean-hidden {
      transform: translate3d(-36px, 0, 0);
      width: 100%;
    }
  }

  &__chip {
    margin-right: 4px !important;
  }

  &__clean-button {
    display: flex;
    transition: transform 0.7s, opacity 0.7s, visibility 0.7s;
    margin-right: 4px;
    visibility: visible;

    &--hidden {
      cursor: default;
      transform: translate3d(-36px, 0, 0) rotate(-0.5turn);
      opacity: 0;
      visibility: hidden;
    }
  }
}
</style>
